import { footLinks, manifesto, siteNav } from "@/mocks/homeContent";

export default function Footer() {
  return (
    <footer className="bg-background-200">
      <div className="mx-auto max-w-7xl px-4 pb-8 pt-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#home" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-sm bg-primary-600 font-heading text-lg font-black text-background-50">
                黑
              </span>
              <span className="font-heading text-2xl font-bold tracking-wide text-foreground-950">黑料社</span>
            </a>
            <p className="mt-5 max-w-md font-heading text-lg font-semibold leading-relaxed text-foreground-800">
              {manifesto.title}
            </p>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">{manifesto.body}</p>
            <div className="mt-6 flex gap-2">
              {["ri-wechat-line", "ri-weibo-line", "ri-zhihu-line", "ri-rss-line"].map((ic) => (
                <a
                  key={ic}
                  href="#home"
                  aria-label="社交入口"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 ring-1 ring-background-300 transition-colors hover:bg-primary-600 hover:text-background-50"
                >
                  <i className={`${ic} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 md:col-span-7">
            {footLinks.map((g) => (
              <div key={g.group}>
                <h4 className="font-heading text-sm font-bold tracking-wide text-foreground-900">{g.group}</h4>
                <ul className="mt-4 space-y-2.5">
                  {g.items.map((it) => (
                    <li key={it}>
                      <a href="#home" className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-700">
                        {it}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            <div>
              <h4 className="font-heading text-sm font-bold tracking-wide text-foreground-900">快捷直达</h4>
              <ul className="mt-4 space-y-2.5">
                {siteNav.map((n) => (
                  <li key={n.key}>
                    <a href={`#${n.key}`} className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-700">
                      {n.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-300/70 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">
            黑料社 深度内容档案 · 理性求证，多源交叉核对后再下结论。
          </p>
          <p className="text-xs text-foreground-500">© 2026 黑料社 Heiliao She · 仅供本站示例展示</p>
        </div>
      </div>
    </footer>
  );
}